module.exports = __webpack_public_path__ + "static/img/partner.7ff7db8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/partner.png
// module id = aaj8
// module chunks = 0